<template>
  <div class="question-answer">
    <LoadingOverlay v-if="isLoading" />
    <component
      v-if="componentToLoad"
      :is="componentToLoad"
      :data="data"
      :lock-answer="lockAnswer"
      :is-active="isActive"
      :labelled-by="labelledBy"
      :disable-keyboard="disableKeyboard"
      ref="answerComponent"
      @answer="onAnswer"
    />
    <div v-else class="answer-type-error">
      <h3>
        {{ $t('question-answer.error-heading') }}
      </h3>
      <p>
        {{ $t('question-answer.unknown-type-error') }}
      </p>
    </div>
  </div>
</template>
<script>
import InputField from './InputField'
import LoadingOverlay from '../LoadingOverlay'
import MultipleChoice from './MultipleChoice'
import { QuestionType } from '../../enums'

export default {
  components: { InputField, LoadingOverlay, MultipleChoice },
  props: {
    lockAnswer: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    labelledBy: {
      type: String,
    },
    disableKeyboard: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    componentToLoad() {
      switch (this.data.Question.type) {
        case QuestionType.INPUT_FIELD:
          return InputField
        case QuestionType.MULTIPLE_CHOICE:
          return MultipleChoice
        default:
          return null
      }
    },
  },
  methods: {
    onAnswer() {
      this.$emit('answer', ...arguments)
    },
    focus() {
      this.$refs.answerComponent.focus()
    },
    blur() {
      this.$refs.answerComponent.blur()
    },
  },
}
</script>

<style scoped>
.question-answer {
  position: relative;
  text-align: center;
}
.answer-type-error {
  background: tomato;
  padding: 1em 2em;
  border-radius: 0.3em;
}
</style>
